// Components
import CasesGrid from '../components/CasesGrid/CasesGrid';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Navigation from '../components/Navigation/Navigation';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import SeoMeta from '../components/SeoMeta/SeoMeta';

import getSeoData from '../utils/data/getSeoData';
import useOpenGraphImage from '../utils/useOpenGraphImage';

// Contentful
import contentfulClient from '../client/contentful';

const Cases = (props) => {
  const { cases } = props;

  const { seoImageURL } = useOpenGraphImage('/home');
  const seoData = getSeoData({ title: 'Cases' }, seoImageURL);

  return (
    <>
      <SeoMeta {...seoData} />
      <PageWrapper>
        <Navigation />
        <Header
          title={['The fastest growing ', 'B2B companies are ', 'using Mutiny']}
          modifier="Header--electricPurple"
        />
        <CasesGrid cases={cases} />
        <Footer />
      </PageWrapper>
    </>
  );
};

export async function getStaticProps() {
  let data = {};
  const client = contentfulClient;

  // Added parameter to make sure client exists in the data so we can show the logo on top of the card
  // https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters/search-on-references
  await client
    .getEntries({
      content_type: 'case',
      'fields.client[exists]': true,
    })
    .then((entries) => {
      data = entries;
    });
  // .catch(console.error);

  return {
    props: {
      cases: data.items,
    },
  };
}

export default Cases;
